import projectsListQuery from '../../api-v2/queries/projects-list-query';
import userListQuery from '../../api-v2/queries/user-list-query';

export const projectsPageLoader = (queryClient) => (opts) => {
  const url = new URL(opts.request.url);
  const page = url.searchParams.get('page') || 1;
  const pageSize = url.searchParams.get('pageSize') || 25;
  const sort = url.searchParams.get('sort') || 'targetCloseDate:asc';
  const search = url.searchParams.get('search') || '';
  const type = url.searchParams.get('type') || '';
  const user = url.searchParams.get('user') || '';
  const state = url.searchParams.get('state') || 'open';
  const status = url.searchParams.get('status') || '';
  const archived = url.searchParams.get('archived') || 'false';
  const pipeline = url.searchParams.get('pipeline');

  const filters = {
    search,
    type,
    user,
    state,
    status,
    archived,
    pipeline,
  };

  queryClient.ensureQueryData(projectsListQuery({ page, pageSize, sort, filters }));
  queryClient.ensureQueryData(userListQuery());

  return { page: parseInt(page, 10), pageSize: parseInt(pageSize, 10), sort, filters };
};

export default projectsPageLoader;
